//GET_APP_TRACK_BY_COMP_LIST
export const GET_ADMIN_APP_TRACK_BY_COMP_LIST_REQUEST =
  "GET_ADMIN_APP_TRACK_BY_COMP_LIST_REQUEST";
export const GET_ADMIN_APP_TRACK_BY_COMP_LIST_SUCCESS =
  "GET_ADMIN_APP_TRACK_BY_COMP_LIST_SUCCESS";
export const GET_ADMIN_APP_TRACK_BY_COMP_LIST_FAIL =
  "GET_ADMIN_APP_TRACK_BY_COMP_LIST_FAIL";
